import { http, HttpResponse } from 'msw'

export const mockSetPolicyAsDefault = http.put(
  '/my-business/api/agency/v1/*/:companyAlphaId/policies/:policyAlphaId/into-use',
  async () => {
    return HttpResponse.json(null, { status: 200 })
  },
)
